/* unplugin-vue-components disabled */import { render } from "./ai-logo.vue?vue&type=template&id=5b82991e&scoped=true"
import script from "./ai-logo.vue?vue&type=script&lang=js"
export * from "./ai-logo.vue?vue&type=script&lang=js"

import "./ai-logo.vue?vue&type=style&index=0&id=5b82991e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b82991e"],['__file',"src/components/ai-chat/ai-logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b82991e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b82991e', __exports__)) {
    api.reload('5b82991e', __exports__)
  }
  
  module.hot.accept("./ai-logo.vue?vue&type=template&id=5b82991e&scoped=true", () => {
    api.rerender('5b82991e', render)
  })

}


export default __exports__